var alertTriggersList = {
	caption: "Alarmlijst",
	noResultsMessage: "Geen resultaten gevonden",
	actions: "Acties",
	trigger: {
		dateTime: "Aanmaakdatum",
		limits: "Limiet",
		limitAbove: "Bovengrens",
		limitBelow: "Ondergrens"
	},
	security: {
		name: "Naam",
		isin: "ISIN",
		lastPrice: "Laatste prijs",
		lastPriceDateTime: "Datum/Tijd",
		assetClass: "Activaklasse",
		exchange: "Markt"
	}
};
var nl = {
	alertTriggersList: alertTriggersList
};

export { alertTriggersList, nl as default };
